"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _dom_component = _interopRequireDefault(require("./component/dom_component"));

var _labels_compact_props = _interopRequireDefault(require("./labels_compact_props"));

var _labels_props = require("./labels_props");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Labels =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Labels, _PureComponent);

  function Labels(props) {
    var _this;

    _classCallCheck(this, Labels);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Labels).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleActiveDataChange", function (event, item) {
      var _this$props = _this.props,
          _this$props$activeDat = _this$props.activeData,
          activeData = _this$props$activeDat === void 0 ? [] : _this$props$activeDat,
          activeFieldName = _this$props.activeFieldName,
          onActiveDataChange = _this$props.onActiveDataChange,
          _this$props$multiple = _this$props.multiple,
          multiple = _this$props$multiple === void 0 ? true : _this$props$multiple;
      var index = (0, _index.isInActiveData)(activeData, item, activeFieldName);
      var newActiveData = (0, _spauiUtils.cloneArray)(activeData);
      var parentNodeClassName = '';

      if (event && event.target) {
        if (event.target.parentNode && event.target.parentNode.className) {
          parentNodeClassName = event.target.parentNode.className || '';
        } // 不能是有del节点的


        if ((0, _spauiUtils.isFunction)(parentNodeClassName.indexOf) && parentNodeClassName.indexOf('del') < 0) {
          if (index > -1) {
            newActiveData.splice(index, 1);
          } else {
            if (activeFieldName) {
              if (_typeof(item) === 'object' && item && (item[activeFieldName] || typeof item[activeFieldName] === 'number')) {
                newActiveData.push(item[activeFieldName]);
              }
            } else {
              newActiveData.push(item);
            }
          }

          if ((0, _spauiUtils.isFunction)(onActiveDataChange)) {
            if (multiple) {
              onActiveDataChange(event, newActiveData);
            } else {
              if (newActiveData.length > 0) {
                onActiveDataChange(event, newActiveData[0]);
              } else {
                onActiveDataChange(event, '');
              }
            }
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLabelClick", function (event, item) {
      var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var onActiveDataChange = _this.props.onActiveDataChange;

      if (!disabled) {
        if (typeof onActiveDataChange !== 'undefined') {
          _this.handleActiveDataChange(event, item);
        }
      }
    });

    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleDelete = _this.handleDelete.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Labels, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "handleClear",
    value: function handleClear(event) {
      var _this$props2 = this.props,
          onClear = _this$props2.onClear,
          onChange = _this$props2.onChange,
          data = _this$props2.data,
          disabled = _this$props2.disabled;
      var result = [];

      if (!disabled) {
        data.map(function (item) {
          if (_typeof(item) === 'object' && (typeof item["delete"] !== 'undefined' && !item["delete"] || typeof item.disabled !== 'undefined' && item.disabled)) {
            result.push(item);
          }

          return item;
        });

        if ((0, _spauiUtils.isFunction)(onClear)) {
          onClear(event);
        }

        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, result);
        }
      }
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(event, deleteItem) {
      var _this$props3 = this.props,
          onDelete = _this$props3.onDelete,
          onChange = _this$props3.onChange,
          data = _this$props3.data,
          disabled = _this$props3.disabled,
          valueFieldName = _this$props3.valueFieldName;
      var result = [];

      if (!disabled) {
        data.map(function (item) {
          if (item !== deleteItem || item[valueFieldName] !== deleteItem[valueFieldName]) {
            result.push(item);
          }

          return item;
        });

        if ((0, _spauiUtils.isFunction)(onDelete)) {
          onDelete(event, deleteItem);
        }

        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, result);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          DeleteComponent = _this$props4.DeleteComponent;

      var _compactProps = (0, _labels_compact_props["default"])(this.props),
          clear = _compactProps.clear;

      var classNameMap = this.getClassNameMap();
      return _react["default"].createElement(_dom_component["default"], _extends({}, this.props, {
        classNameMap: classNameMap,
        clear: clear,
        devProps: [Labels, this.props],
        className: (0, _classnames["default"])(classNameMap.Labels, 'clearfix', className),
        onClear: this.handleClear,
        onDelete: this.handleDelete,
        onLabelClick: this.handleLabelClick,
        DeleteComponent: DeleteComponent
      }), children);
    }
  }]);

  return Labels;
}(_react.PureComponent); // 组件标记


_defineProperty(Labels, "propTypes", _labels_props.propTypes);

_defineProperty(Labels, "defaultProps", _labels_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Labels, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Labels;
exports["default"] = _default;